import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@material-ui/core';
import App from './App';
import { TravelGuideProvider, useTravelGuide } from './context/TravelGuideContext';
import './styles.css';

const ThemeBridge = () => {
  const { theme } = useTravelGuide();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  );
};

const Root = () => (
  <BrowserRouter>
    <TravelGuideProvider>
      <ThemeBridge />
    </TravelGuideProvider>
  </BrowserRouter>
);

ReactDOM.render(<Root />, document.getElementById('root'));
